var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserDesignation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6554 10.3506C21.6332 10.3357 21.6103 10.322 21.5867 10.3094L20.0255 9.46875L11.3677 14.0526C11.1377 14.1744 10.8623 14.1744 10.6323 14.0526L1.97458 9.46875L0.41334 10.3094C0.0338959 10.5109 -0.110479 10.9817 0.0909369 11.3612C0.103459 11.3848 0.117178 11.4077 0.132049 11.4299L11 17.1836L21.868 11.4299C22.1074 11.0731 22.0122 10.5899 21.6554 10.3506Z",
    fill: "#4C4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9049 15.3425C21.8321 15.2077 21.7215 15.097 21.5867 15.0243L20.0255 14.1836L11.3677 18.7675C11.1377 18.8893 10.8623 18.8893 10.6323 18.7675L1.97451 14.1836L0.413272 15.0243C0.031387 15.2304 -0.111054 15.707 0.0950575 16.0889C0.167843 16.2238 0.278473 16.3344 0.413272 16.4071L10.6276 21.9071C10.8601 22.0323 11.1399 22.0323 11.3724 21.9071L21.5867 16.4071C21.9685 16.201 22.111 15.7244 21.9049 15.3425Z",
    fill: "#4C4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6554 5.63501C21.6332 5.62014 21.6103 5.60642 21.5867 5.59389L11.3725 0.0938828C11.14 -0.0312943 10.8601 -0.0312943 10.6276 0.0938828L0.41334 5.59389C0.0338959 5.79531 -0.110479 6.26619 0.0909369 6.64563C0.103459 6.6692 0.117178 6.69213 0.132049 6.71432L11 12.4681L21.868 6.71432C22.1074 6.35757 22.0122 5.87436 21.6554 5.63501Z",
    fill: "#4C4F5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDesignation);
export default __webpack_public_path__ + "static/media/user-designation.24a2d8effe3affbe46007fd0440ac8d6.svg";
export { ForwardRef as ReactComponent };